// FeedSkeleton.tsx — Phase 11 Step 3 Block 5
// Loading-State für den Feed. Rendert Shell-Layout mit Platzhalter-Tiles.
//
// Reduziert auf:
//   - CategoryChips-Instanz (kontrolliert, aktive "all" — reine Decoration, kein State)
//   - LoggedOutHero (Titel/Copy = Content, kein Skeleton)
//   - 1 SkeletonHero
//   - 2 CardGrids × 4 SkeletonCard
//
// Extrahierte Sub-Components leben jetzt in eigenen Files:
//   - CategoryChips        → components/feed/CategoryChips.tsx
//   - SectionTitle         → components/feed/SectionTitle.tsx
//   - CardGrid             → components/feed/CardGrid.tsx
//   - LoggedOutHero        → components/home/LoggedOutHero.tsx
//
// `aria-hidden="true"` + `role="presentation"` auf den Skeleton-Tiles — Assistive
// Tech soll das Platzhalter-Gitter überspringen.

import { VARIANT } from "../../lib/tokens";
import { SkeletonCard, SkeletonHero } from "../common/Skeleton";
import { useVariant } from "../../hooks/useVariant";
import { CategoryChips } from "./CategoryChips";
import { SectionTitle } from "./SectionTitle";
import { CardGrid } from "./CardGrid";
import { LoggedOutHero } from "../home/LoggedOutHero";

export function FeedSkeleton() {
  const { variant } = useVariant();
  const v = VARIANT[variant];

  return (
    <div style={{ background: v.bg, minHeight: "100%" }}>
      {/* Chips lesen den Active-State jetzt aus pageContext.urlPathname —
          der Skeleton zeigt sie einfach statisch. Auf `/` ist "Für dich" aktiv. */}
      <CategoryChips />

      <div
        style={{
          padding: "32px 32px 80px",
          maxWidth: 1600,
          margin: "0 auto",
        }}
      >
        <LoggedOutHero />

        <div role="presentation" aria-hidden="true">
          <SkeletonHero variant={variant} />
        </div>

        <SectionTitle
          title="Im Trend"
          subtitle="Die Scrollys, über die alle sprechen"
        />
        <CardGrid>
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} role="presentation" aria-hidden="true">
              <SkeletonCard variant={variant} />
            </div>
          ))}
        </CardGrid>

        <SectionTitle title="Empfehlungen der Redaktion" />
        <CardGrid>
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={`e${i}`} role="presentation" aria-hidden="true">
              <SkeletonCard variant={variant} />
            </div>
          ))}
        </CardGrid>
      </div>
    </div>
  );
}
